import { useState } from 'react'
import CommunityFeed   from './CommunityFeed'
import BestPracticeHub from './BestPracticeHub'
import LiveEvents      from './LiveEvents'
import { useSidebar }  from '../../contexts/SidebarContext'

export default function CommunityPanel() {
  const { closeSidebars } = useSidebar()
  // 🔥 ANDROID BACK BUTTON INTEGRATION
  // Allow native back button to close the Community Panel
  if (typeof window !== "undefined") {
    window.closeCommunityPanel = () => {
      closeSidebars();
    };
  }
  const [tab, setTab] = useState('feed')

  const TABS = {
    feed: { label: 'Feed', component: <CommunityFeed /> },
    best: { label: 'Best-Practice Hub', component: <BestPracticeHub /> },
    live: { label: 'Live Events', component: <LiveEvents /> },
  }

  return (
    <section className="flex flex-col h-full bg-white">
      {/* header */}
      <header className="flex items-center gap-2 px-4 py-2 border-b border-light-gray">
        {Object.entries(TABS).map(([id, t]) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            className={`
              px-4 py-2 min-h-[44px] rounded-full text-base
              whitespace-nowrap transition
              ${tab === id
                ? 'bg-soft-yellow/70 text-charcoal font-medium'
                : 'hover:bg-soft-yellow/40 text-slate-gray'}
            `}
          >
            {t.label}
          </button>
        ))}

        <span className="flex-1" />

        <button
          onClick={closeSidebars}
          aria-label="close"
          className="
            text-slate-gray hover:text-charcoal 
            px-4 py-3 min-h-[44px] rounded-md
          "
        >
          ✕
        </button>
      </header>

      {/* body */}
      <div className="flex-1 overflow-y-auto">
        {TABS[tab].component}
      </div>
    </section>
  )
}